/**
 * FOLD file format (https://github.com/edemaine/FOLD).
 *
 * Fold reads and writes FOLD 1.2. Only the fields listed here are given
 * first-class treatment; everything else on the object is preserved verbatim
 * on round-trip so that files from other tools do not lose information.
 */
export type FoldEdgeAssignment = 'B' | 'M' | 'V' | 'F' | 'U' | 'C' | 'J';

export interface FoldFile {
  file_spec?: number;
  file_creator?: string;
  file_author?: string;
  file_title?: string;
  file_description?: string;
  file_classes?: string[];
  file_frames?: FoldFrame[];

  frame_title?: string;
  frame_description?: string;
  frame_author?: string;
  frame_classes?: string[];
  frame_attributes?: string[];
  frame_unit?: string;

  vertices_coords?: number[][];
  vertices_vertices?: number[][];
  vertices_faces?: (number | null)[][];

  edges_vertices?: [number, number][];
  edges_assignment?: FoldEdgeAssignment[];
  edges_foldAngle?: (number | null)[];
  edges_length?: number[];
  edges_faces?: (number | null)[][];

  faces_vertices?: number[][];
  faces_edges?: number[][];

  faceOrders?: [number, number, number][];
  edgeOrders?: [number, number, number][];

  [key: string]: unknown;
}

export interface FoldFrame extends FoldFile {
  frame_parent?: number;
  frame_inherit?: boolean;
}

export const FOLD_SPEC_VERSION = 1.2;
/** Written into `file_creator`. The domain disambiguates the app from the format. */
export const FOLD_CREATOR = 'fold.app';
